import {
  KdsAvatar,
  KdsHeader,
  type KdsHeaderProps,
  KdsText,
} from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { getUserFullName } from "@/helpers/getUserFullName";
import { useUserCanEditOrder } from "@/hooks/orders/useUserCanEditOrder";
import { useRolePermission } from "@/hooks/rolePermission/useRolePermission";
import { type NewRequestPageHeaderProps } from "./NewRequestPageHeader.types";

export const NewRequestPageHeader = ({
  isScrolled,
  orderItem,
  order,
  handleDeleteRequest,
  handleQualifyDrawerOpen,
}: NewRequestPageHeaderProps) => {
  const { t } = useTranslate();
  const navigate = useNavigate();
  const { isBrokerAccount, isKazaarAccount } = useRolePermission();

  const isUserCanEditOrder = useUserCanEditOrder(order);

  const creationLog = orderItem.OrderLog[0];

  const headerBrokerButton: KdsHeaderProps["buttons"] = [
    {
      buttonType: "button",
      color: "neutral",
      variant: "outlined",
      children: t("buttons.qualifyProduct"),
      onPress: handleQualifyDrawerOpen,
    },
  ];

  const headerClientButton: KdsHeaderProps["buttons"] = [
    {
      buttonType: "button",
      color: "error",
      variant: "outlined",
      disabled: !isUserCanEditOrder,
      children: t("buttons.deleteRequest"),
      onPress: handleDeleteRequest,
    },
  ];

  return (
    <KdsHeader
      title={t("newRequest.title")}
      metadatas={[
        <div key="user">
          <KdsAvatar
            size="xs"
            type="image"
            name={getUserFullName({
              firstName: creationLog?.user?.firstName,
              lastName: creationLog?.user?.lastName,
            })}
          />
          <KdsText color="text-bodyvariant">
            {getUserFullName({
              firstName: creationLog?.user?.firstName,
              lastName: creationLog?.user?.lastName,
            })}
          </KdsText>
        </div>,
        <KdsText key="createdAt" color="text-bodyvariant">
          {t("historicRecord.dateEvent", {
            date: dayjs(orderItem.createdAt).format("L"),
            time: dayjs(orderItem.createdAt).format("LT"),
          })}
        </KdsText>,
      ]}
      backButtonProps={{
        onPress: () => void navigate(`/orders/${orderItem.orderId}`),
      }}
      isScrolled={isScrolled}
      buttons={
        isBrokerAccount || isKazaarAccount
          ? [...headerClientButton, ...headerBrokerButton]
          : headerClientButton
      }
    />
  );
};
